export function getPageItems(current, total, siblings = 1) {
    const first = 1;
    const last = total;
  
    // Small totals: show all pages
    if (total <= 5) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }
  
    const start = Math.max(current - siblings, first + 1);
    const end = Math.min(current + siblings, last - 1);
  
    const items = [first];
  
    if (start > first + 1) items.push('ellipsis'); // left gap
  
    for (let p = start; p <= end; p++) items.push(p);
  
    if (end < last - 1) items.push('ellipsis'); // right gap
  
    if (last > first) items.push(last);
  
    return items;
  }
  